// store/authSlice.js
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  userName: localStorage.getItem("userName") || null,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setUserName: (state, action) => {
      state.userName = action.payload;
      localStorage.setItem("userName", action.payload);
    },
    logout: (state) => {
      state.userName = null;
      localStorage.removeItem("userName");
    },
  },
});

export const { setUserName, logout } = authSlice.actions;
export default authSlice.reducer;